import {
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

export const TREE_DND_MOUSE_ACTIVATION = { distance: 6 } as const;
export const TREE_DND_TOUCH_ACTIVATION = { delay: 250, tolerance: 5 } as const;

/**
 * Mouse drags after 6px (as before); touch drags only after a 250 ms hold, so
 * a finger sliding over the handle scrolls the page instead of dragging.
 */
export function useTreeDndSensors() {
  return useSensors(
    useSensor(MouseSensor, {
      activationConstraint: TREE_DND_MOUSE_ACTIVATION,
    }),
    useSensor(TouchSensor, {
      activationConstraint: TREE_DND_TOUCH_ACTIVATION,
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
}
